import React, { useState } from 'react';
import html2canvas from 'html2canvas';
import JSZip from 'jszip';
import { saveAs } from 'file-saver';

import canvas2image from './canvas2image';
import AllIcons from './AllIcons';
import Controls from './Controls';
import STYLES from './App.scss';

const c = className => STYLES[className] || 'UNKNOWN';

const App = () => {
  const [foregroundColor, setForegroundColor] = useState('#000000');
  const [backgroundColor, setBackgroundColor] = useState('#000000');
  const [strokeColor, setStrokeColor] = useState('#000000');
  const [strokeWidth, setStrokeWidth] = useState(1);

  const save = () => {
    const zip = new JSZip();
    const images = document.querySelectorAll('[data-type="icon-wrapper"]');
    let imagesProcessed = 0;
    images.forEach(image => {
      html2canvas(image).then(canvas => {
        const base64encoding = canvas2image.getImageContentsPNG(canvas);
        zip.file(`${image.id}.png`, base64encoding, { base64: true });
        imagesProcessed += 1;
        if (imagesProcessed === images.length) {
          zip
            .generateAsync({ type: 'blob' })
            .then(content => saveAs(content, 'images.zip'));
        }
      });
    });
  };

  return (
    <div className={c('App')}>
      <header className={c('App__header')}>
        <div className={c('App__header-inner')}>
          <h1>Iconic</h1>
          <p>
            Configure the icons to your heart&apos;s desire with the tools
            below.
          </p>
        </div>
      </header>
      <main className={c('App__main')}>
        <Controls
          foregroundColor={foregroundColor}
          setForegroundColor={setForegroundColor}
          backgroundColor={backgroundColor}
          setBackgroundColor={setBackgroundColor}
          strokeColor={strokeColor}
          setStrokeColor={setStrokeColor}
          strokeWidth={strokeWidth}
          setStrokeWidth={setStrokeWidth}
        />
        <AllIcons />
        <button type="button" onClick={save}>
          Download
        </button>
      </main>
    </div>
  );
};

export default App;
